import Vue from 'vue'
import { serialize } from 'object-to-formdata'
import Form from 'vform'
import {
    HasError,
    AlertError,
    AlertErrors,
    AlertSuccess
} from 'vform/src/components/bootstrap5'

window.Form = Form

Vue.component(HasError.name, HasError)
Vue.component(AlertError.name, AlertError)
Vue.component(AlertErrors.name, AlertErrors)
Vue.component(AlertSuccess.name, AlertSuccess)


/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require('popper.js').default
    window.$ = window.jQuery = require('jquery')

    require('bootstrap')
} catch (e) {}

window._ = require('lodash')
window.serialize = serialize
window.slugify = require('slugify')
window.intlTelInput = require('intl-tel-input')
window.feather = require('feather-icons')
window.DataTable = require('datatables.net')
window.flot = require('flot/dist/es5/jquery.flot')
window.select2 = require('select2')

require('flot/source/jquery.flot.time')
require('flot/lib/jquery.mousewheel')

require('datatables.net-dt/js/dataTables.dataTables.min')

require('es6-promise').polyfill()

require('./scripts')
require('./directives')
require('./filters')
require('./mixins')

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the 'XSRF' token cookie.
 */

window.axios = require('axios')

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
